export const NO_PROMOTION = 'NO_PROMOTION';
export const promotionKeys = {
  HSFS_SEED_V2: 'HSFS_SEED_V2',
  HSFS_SEED_V3: 'HSFS_SEED_V3',
  HSFX_ENTREPRENEUR_V2: 'HSFX_ENTREPRENEUR_V2',
  HSFX_BOOTSTRAP: 'HSFX_BOOTSTRAP',
  STRATEGIC_PARTNERSHIP: 'STRATEGIC_PARTNERSHIP',
  HSFS_SERIES_A_V2: 'HSFS_SERIES_A_V2'
};